<template>
	<div>
		<svg :width="iconSize" :height="iconSize" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M10.0667 0.474961C10.3291 0.300013 10.671 0.300013 10.9334 0.474961L20.3084 6.72496C20.6675 6.9643 20.7645 7.44935 20.5251 7.80836C20.2858 8.16737 19.8007 8.26438 19.4417 8.02504L10.5001 2.06395L1.55844 8.02504C1.19944 8.26438 0.714382 8.16737 0.475044 7.80836C0.235706 7.44935 0.332717 6.9643 0.691724 6.72496L10.0667 0.474961Z"
				:fill="color" 
			/>
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="M19.0938 8.76302V19.0938H19.875C20.3065 19.0938 20.6563 19.4435 20.6563 19.875C20.6563 20.3065 20.3065 20.6562 19.875 20.6562H1.125C0.693528 20.6562 0.34375 20.3065 0.34375 19.875C0.34375 19.4435 0.693528 19.0938 1.125 19.0938H1.90625V8.76302C1.90625 8.3783 2.18633 8.05085 2.5664 7.99122C5.15185 7.58554 7.80161 7.375 10.5 7.375C13.1984 7.375 15.8481 7.58554 18.4336 7.99122C18.8137 8.05085 19.0938 8.3783 19.0938 8.76302ZM11.2813 11.2812C11.2813 10.8498 10.9315 10.5 10.5 10.5C10.0685 10.5 9.71875 10.8498 9.71875 11.2812V18.3125C9.71875 18.744 10.0685 19.0938 10.5 19.0938C10.9315 19.0938 11.2813 18.744 11.2813 18.3125V11.2812ZM14.4063 10.5C14.8377 10.5 15.1875 10.8498 15.1875 11.2812V18.3125C15.1875 18.744 14.8377 19.0938 14.4063 19.0938C13.9748 19.0938 13.625 18.744 13.625 18.3125V11.2812C13.625 10.8498 13.9748 10.5 14.4063 10.5ZM7.375 11.2812C7.375 10.8498 7.02522 10.5 6.59375 10.5C6.16228 10.5 5.8125 10.8498 5.8125 11.2812V18.3125C5.8125 18.744 6.16228 19.0938 6.59375 19.0938C7.02522 19.0938 7.375 18.744 7.375 18.3125V11.2812Z"
				:fill="color" 
			/>
			<path
				d="M10.5 6.20312C11.1472 6.20312 11.6719 5.67846 11.6719 5.03125C11.6719 4.38404 11.1472 3.85938 10.5 3.85938C9.85279 3.85938 9.32813 4.38404 9.32813 5.03125C9.32813 5.67846 9.85279 6.20312 10.5 6.20312Z"
				:fill="color" 
			/>
		</svg>

	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null
		}
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		}
	}
};
</script>

<style scoped>

</style>